import React from 'react';
import { unescape } from 'lodash';

import style from '../index.module.css';

import Placeholder from '../../../static/images/placeholder.svg';

type CreatorCardProps = {
    eyebrowText?: string;
    image?: string;
    imageAltText?: string;
    promoType: string;
    title?: string;
    type?: string;
    url?: string;
};

const CreatorCard = ({ eyebrowText, image, imageAltText, promoType, title, type, url }: CreatorCardProps) => {
    return (
        <div className={style.cardPromo} data-type={promoType}>
            <div className={`${style.imageContainer} ${style.circle}`}>
                {/* Remove tabindex so users don't have to tab through cards twice (they are both the same link) */}
                <a href={url} tabIndex={-1}>
                    <img src={image ? image : Placeholder} alt={imageAltText ? imageAltText : unescape(title)} />
                </a>
            </div>

            <div className="info">
                <a href={url}>
                    <h3 className={style.creator}>{unescape(title)}</h3>

                    {eyebrowText && <div className={style.title}>{eyebrowText}</div>}

                    <div className={style.role}>{type}</div>
                </a>
            </div>
        </div>
    );
};

export default CreatorCard;
